export const tradingContest = {
  cyjyds: "參與交易大賽",
  jsjxmh: "解鎖驚喜盲盒，贏得超級大獎！",
  hdsj: "活動時間",
  mrjxsj: "每日00:00至23:59 UTC+8進行。",
  ckxxgz: "查看詳細規則",
  wdjj: "我的獎金",
  jlkj: "距離開獎",
  cjjc: "超級獎金池",
  jjmrzj: "獎金每日累積增加",
  kqxjd: "開啟新階段，獎勵數量增加",
  dyjd: "第一階段",
  dejd: "第二階段",
  dsjd: "第三階段",
  dsijd: "第四階段",
  jrmhjj: "今日盲盒獎金",
  syjj: "剩餘獎金",
  yblqje: "已被領取金額",
  tjmh: "特級盲盒",
  yjmh: "一級盲盒",
  ejmh: "二級盲盒",
  sjmh: "三級盲盒",
  jj: "獎金：",
  gs: "個",
  djdkrymh: "點擊打開任何一個驚喜盲盒",
  kydk: "您今天可以打開",
  jxmh: "驚喜盲盒",
  dkmhxyxx: "打開一個盲盒需要 {amount}個星星。",
  xzyyxx: "您現在擁有{{amount}}個星星",
  xxqlsj: "星星清零時間：{date} （請在星星清零前領取盲盒）",
  wdxx: "我的星星",
  xxhq: "星星獲取",
  hqxxtj: "取得星星途徑",
  yxhysxf: "永續合約：每{amount}U手續費獲1顆星星",
  qqhysxf: "選擇權合約：每{amount}U交易金額可獲得1顆星星",
  youxihysxf: "GameFi：每{amount}U交易金額可獲得1顆星星",
  gxhd: "恭喜您已獲得",
  jlydrzh: "此獎勵已打入您的「{account}」",
  qzjzhck: "去趣投帳戶查看",
  bwcjjc: "幣王超級獎池",
  qmxjyds: "全明星交易大賽",
  gbgbyb: "敢不敢來搏一把？",
  bwcjjcdnn: "幣王超級獎池，每天{amount}%盲盒大獎隨你拿！",
  cjjcqmxjys: "幣王超級獎金池全明星交易獎池{amount}%每天加盲盒，",
  syyxbd: "隨手一開以小搏大！",
  zgtk: "想登頂？來戰個痛快！",
  zhyz: "每日獎金池{amount}%累積至最後一戰，",
  dfdj: "誰能拿下幣王巔峰大獎？",
  gsjj: "幣王超級獎池全明星交易比賽高手聚集，",
  qmxpk: "全明星PK見真章！",
  jymh: "交易、盲盒、衝榜，玩轉幣王賽場！",
  zzbzy: "永續合約、選擇權、GameFi、現貨交易，四周玩法層層升級，週週不重樣！",
  jlfh: "幣王超級獎金池全明星交易大賽，獎勵豐厚等你名利雙收英雄稱王！",
  mh: "盲盒",
  cb: "衝榜",
  jy: "交易",
  syxxs: "剩餘星星數",
  xxbhs: "星星變化數量",
  sjlx: "事件類型",
  jycp: "交易產品",
  jye: "交易額",
  myxgjl: "您還沒有獲得相關獎勵哦",
  jyhd: "交易獲得",
  ql: "清零",
  kqmh: "開啟盲盒",
  yx: "GameFi遊戲",
  bchdyjs: "本次活動已結束",
  gffjj: "本次大賽共發放獎金",
  kqmhsl: "開啟盲盒數量",
  cjjcjj: "超級獎池獎金",
  cjjchjmd: "超級獎金池得獎名單",
  jjdyyh: "獎金已打入用戶資金帳戶",
  hdjj: "獲得獎金",
  wff: "未發放",
  mhhjjl: "盲盒獲獎記錄",
  cjdjhjjl: "超大獎得獎紀錄",
  jjse: "獎金數額",
  xhxxs: "消耗星星數",
  bwqmxgz: "幣王全明星交易大賽活動規則",
  hdnr: "活動內容",
  hdnrgz: "幣王超級獎池全明星交易比賽涵蓋永續合約、選擇權合約、GameFi遊戲及現貨交易四大領域。活動分為四周，每週逐步解鎖新的交易產品，讓您在多維度的交易挑戰中獲得「星星」並贏取豐厚獎勵。每日獎金池{total}%用於盲盒抽獎，驚喜獎勵即開即得！剩餘的{amount}%累積至大賽結束，依交易排名瓜分最高獎勵！",
  hdjd: "活動階段",
  jbjs: "逐步解鎖，四個週期競賽升級",
  dyzq: "第一週期",
  kqyxhy: "開啟永續合約交易，交易量越高，星星積分越多，獎金池獎勵越高！",
  dezq: "第二週期",
  jmqqjy: "加碼選擇權合約交易，交易盈虧雙向累積獎金池，讓您的星星數量再次升級。",
  dszq: "第三週期",
  cjgejc: "加入GameFi遊戲，透過多元交易體驗獲取星星，衝擊高額獎金池。",
  dsizq: "第四週期",
  gfzzdj: "前三週盲盒獎池繼續開放，現貨交易榜單獨設立，瓜分最終大獎！",
  jzszjs: "獎池獎金數值計算",
  jxmhgz1: "每日獎池的{amount}%發放至盲盒，100個盲盒即開即領，四個等級的獎品讓您體驗時刻驚喜。未領取獎勵自動累積到次日獎池，讓收益持續增長！特級盲盒、一級盲盒等每日刷新，超高中獎率等您來開！",
  mhfpmx: "每日總盲盒數量{total}個，總活動獎金池{amount}%。",
  tjmhzb: "特級盲盒{total}個，參與{amount}%獎池",
  yjmhzb: "一級盲盒{total}個，佔{amount}%獎池",
  ejmhzb: "二級盲盒{total}個，參與{amount}%獎池",
  sjmhzb: "三級盲盒{total}個，參與{amount}%獎池",
  kmhxxyq: "開盲盒所需的星星數量要求：每日盲盒獎池金額/{text}",
  tips: "注意：所有盲盒對應獎勵每日0點刷新，按前一代產生的各產品交易盈虧獎池+前一代開盒剩餘金額重新計算，按以上等級與比例分的金額配發到當日盲盒中。",
  mrjyyk: "總獎池根據永續合約、選擇權合約、GameFi三大板塊交易每日交易盈虧。",
  mgyld: "每一個獲利單的{amount}% =獲利金額*{amount}%",
  mrjcljdjs: "每日獎池的{amount}%累積到活動結束，由四大交易產品的排行榜前三名瓜分，延續獎池比例分別為：永續合約40%，選擇權30%，GameFi 20%，現貨10%。",
  yhhyyld: "例如：用戶合約訂單獲利1000U，則1000*{amount}%={total}U進入當日獎金池",
  mgksd: "每一個虧損單的{amount}%=實際虧損金額（虧損-穿倉回補）*{amount}%",
  yhhyks: "例如：用戶合約訂單實際虧損1000U，則1000*{amount}%={total}U進入當日獎金池",
  qqhyyld: "每一個獲利單的{amount}% =投注金額*賠率*{amount}%",
  qqyhddtz: "例如：用戶選擇權訂單投注100U，10秒週期獲利，則100*65%*{amount}%={total}U進入當日獎池",
  qqhyksd: "每一個虧損單的{amount}%=虧損金額*{amount}%",
  yhksjrjc: "例如：用戶選擇權訂單虧損100U，則100*{amount}%={total}U進入當日獎金池",
  yxyld: "每一個獲利單的{amount}% =投注金額*賠率*{amount}%",
  yxddtz: "例如：用戶gamefi訂單投注100U，假設賠率2倍。獲利，則100*200%*{amount}%={total}U進入當日獎金池",
  yxmgksd: "每一個虧損單的{amount}%=虧損金額*{amount}%",
  yhqqksd: "例如：用戶選擇權訂單虧損100U，則100*{amount}%={total}U進入當日獎金池",
  daiding: "待定",
  yytz: "活動調整",
  kaiqi: "開啟",
  xhjyjrpm: "現貨交易加入排名",
  drjy: "當日交易 隔日獲得",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/tw.js